import React, { useEffect } from 'react';
import { useAuth } from '../auth/AuthContext'; // Pfad anpassen!

/**
 * Eine einfache Tracking-Komponente, die Seitenaufrufe protokolliert und 
 * die Benutzeraktivität in regelmäßigen Abständen aktualisiert.
 * Diese Komponente rendert nichts sichtbares und arbeitet nur im Hintergrund.
 */
const Tracking: React.FC = () => {
  const { user } = useAuth();
  const API_URL = window.location.protocol + '//' + window.location.host + '/api';

  useEffect(() => {
    // Ein separater localStorage-Schlüssel für das Tracking
    const TRACKING_LAST_ACTIVITY_KEY = 'trackingLastActivity';
    const CHECK_INTERVAL = 5 * 60 * 1000; // 5 Minuten
    
    // Initialen Zeitstempel setzen
    localStorage.setItem(TRACKING_LAST_ACTIVITY_KEY, Date.now().toString());
    
    console.log('Tracking component initialized for user:', user?.id || 'anonymous');

    // Seitenaufruf protokollieren - für alle Benutzer, auch nicht angemeldete
    const trackPageVisit = async () => {
      try {
        const userId = user ? user.id : null; // User ID kann null sein für nicht angemeldete Benutzer
        const currentUrl = window.location.pathname + window.location.search;
        
        console.log('Tracking page visit:', currentUrl, 'User ID:', userId || 'anonymous');
        
        const response = await fetch(`${API_URL}/auth/admin.php?action=track-visit`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ 
            user_id: userId, 
            page_url: currentUrl 
          }),
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      } catch (error) {
        console.error('Error tracking page visit:', error);
      }
    };

    // Benutzeraktivität aktualisieren - nur für angemeldete Benutzer
    const updateUserActivity = async () => {
      if (!user) return; // Nur für angemeldete Benutzer
      
      try {
        const response = await fetch(`${API_URL}/auth/admin.php?action=update-activity`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ user_id: user.id }),
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        // Trackingzeitstempel aktualisieren
        localStorage.setItem(TRACKING_LAST_ACTIVITY_KEY, Date.now().toString());
      } catch (error) {
        console.error('Error updating user activity:', error);
      }
    };

    // Seitenaufruf beim Laden protokollieren
    trackPageVisit();
    
    // Benutzeraktivität beim Laden aktualisieren
    updateUserActivity();
    
    // Timer für regelmäßige Aktualisierung der Aktivität
    const activityInterval = setInterval(() => {
      updateUserActivity();
    }, CHECK_INTERVAL);
    
    // Cleanup beim Unmount
    return () => {
      clearInterval(activityInterval);
    };
  }, [user]); // Nur neu ausführen, wenn sich der Benutzer ändert

  return null; // Diese Komponente rendert nichts
};

export default Tracking;